export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-white text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white whitespace-nowrap">芭乐视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-md">
              芭乐视频聚合红桃视频、樱花视频、糖豆视频等特色视频平台内容，提供高清免费在线观看。无需缓冲，最新电视剧电影资源一应俱全，致力于为观众打造流畅便捷的一站式观影入口。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors">精选推荐</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors">最新动态</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors">热度榜单</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 芭乐视频. 本站聚合展示各平台公开内容，仅供学习交流。
          </p>
          <p className="text-xs text-background-500">
            红桃视频 · 樱花视频 · 糖豆视频 · 高清不缓冲
          </p>
        </div>
      </div>
    </footer>
  );
}